module.exports = __webpack_public_path__ + "static/media/mini_menagerie.b22e9d35.JPG";